/**
 * SF-4746: who may act on a build (approve, cancel, carry on, draft again, dismiss, send, upload,
 * the demo login). Only its creator, and only while they still hold admin:demos:create: someone who
 * started a build and now holds only "See all prospect demos" reads it like anyone else's. Nothing
 * is offered while permissions load or when is_mine is not an explicit true. sf-api refuses them
 * anyway; whether the build's state allows each action stays sf-api's (can_draft_again, can_dismiss).
 */
import { usePermissions } from '@refinedev/core';
import { hasPermission } from '../../utils/permissions';
import { DEMOS_PERMISSION } from './constants';

export function useCanActOn() {
  const { data: permissions, isLoading } = usePermissions<string[]>();
  const canCreate = !isLoading && hasPermission(permissions ?? [], DEMOS_PERMISSION);
  return (build: { is_mine?: boolean } | undefined) => canCreate && build?.is_mine === true;
}
